import React, { Component } from 'react'
import anime from 'animejs';
import lottie from 'lottie-web';
import animationData from './rocket-data.json'
import { BlobFiller } from 'src/components/blob-filler/BlobFiller';
import { inViewService } from 'src/services/InViewService';
import bodyAnchors from './anchor-data/body';
// import finAnchors from './anchor-data/fin';
// import noseAnchors from './anchor-data/nose';
import "./Rocket.scss";

export class Rocket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInView: true,
      isStopped: true,
    }

  }
  componentDidMount() {
    // TODO: convert BlobFiller to share canvas
    // this.app = new pixi.Application({
    //   width: 200,
    //   height: 350,
    //   antialias: true,
    //   transparent: true,
    //   resolution: 1,
    // });
    inViewService.add({id: 'rocket', element: this.refs.rocket, onScroll: isInView => this.onScroll(isInView)});
    // this.refs.animation.play();

    // Use this instead of Lottie React Web (both libs with that name) since that can't play the animation back correctly
    this.animationControl = lottie.loadAnimation({
      container: this.refs.animation, // the dom element that will contain the animation
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData,
    });

    this.animationControl.addEventListener('complete', this.onAnimationFinish);
    this.followRocket();
    this.animationControl.goToAndPlay(0);
  }

  componentWillUnmount() {
    inViewService.remove('rocket');
    this.animationControl.removeEventListener('loopComplete', this.onAnimationFinish);
    this.animationControl.destroy();
  }

  onScroll(isInView) {
    this.setState({
      isInView,
    });
  }

  // Synchronize with animation
  onAnimationFinish = () => {
    // this.animationControl.removeEventListener('complete', this.onAnimationFinish);

    this.animationControl.goToAndPlay(0);
    this.followRocket();
  }

  followRocket() {
    if (this.animeControl) {
      this.animeControl.pause();
    }
    this.animeControl = anime({
      targets: this.refs.rocketBlob,
      keyframes: [
        {translateY: 70 },
        {translateY: 30, duration: 2500, delay: 1300 },
        {translateY: 60, duration: 2200, delay: 100 },
        {translateY: 70, duration: 3000, delay: 2000 },
      ]
    });
  }

  render() {
    const { app } = this;
    return (
      <div className="Rocket" ref="rocket">
        <div ref="animation" />
        {/* <Lottie ref="animation"
          options={{
              animationData: animation,
              loop: false,
              autoplay: false,
              renderer: 'svg',
            }}
            eventListeners={[
              {
                eventName: 'complete',
                callback: (e) => this.onAnimationFinish(),
              },
            ]}
        /> */}
        <div className="Rocket-blob" ref="rocketBlob">
          <BlobFiller fill={{
              anchors: bodyAnchors,
              x: 20,
              y: 20,
              color: 0xF0325A,
              wobbleVariation: {position: 5 },
            }}
            isInView={this.state.isInView}
            width={200} height={300}
            x={120} y={60}
          />
          {/* <BlobFiller anchors={noseAnchors} isInView={this.state.isInView}
            x={100} y={20} centerX={20} centerY={20}
            width={200} height={300}
            color={0xF0325A}
            />
          <BlobFiller anchors={finAnchors} isInView={this.state.isInView}
            x={90} y={40} centerX={20} centerY={20}
            width={200} height={300}
            color={0xF0325A}
            />*/}
          </div>
      </div>
    )
  }
}
